import { createApp } from "vue";
import hljs from 'highlight.js';
import GenesisContentBlocks from "./components/GenesisContentBlocks.vue"

hljs.highlightAll();

require('./vendor/bootstrap.js');
require('./main.js');

const app = createApp({});
createApp({}).mount("#app");
app.component("genesis-content-block", GenesisContentBlocks);
app.mount("#app");